// Complete list of country codes with flags
export const countryCodes = [
  { code: "+39", country: "Italy", flag: "🇮🇹", iso: "IT" },
  { code: "+1", country: "USA/Canada", flag: "🇺🇸", iso: "US" },
  { code: "+44", country: "United Kingdom", flag: "🇬🇧", iso: "GB" },
  { code: "+49", country: "Germany", flag: "🇩🇪", iso: "DE" },
  { code: "+33", country: "France", flag: "🇫🇷", iso: "FR" },
  { code: "+34", country: "Spain", flag: "🇪🇸", iso: "ES" },
  { code: "+40", country: "Romania", flag: "🇷🇴", iso: "RO" },
  { code: "+31", country: "Netherlands", flag: "🇳🇱", iso: "NL" },
  { code: "+32", country: "Belgium", flag: "🇧🇪", iso: "BE" },
  { code: "+43", country: "Austria", flag: "🇦🇹", iso: "AT" },
  { code: "+41", country: "Switzerland", flag: "🇨🇭", iso: "CH" },
  { code: "+48", country: "Poland", flag: "🇵🇱", iso: "PL" },
  { code: "+351", country: "Portugal", flag: "🇵🇹", iso: "PT" },
  { code: "+30", country: "Greece", flag: "🇬🇷", iso: "GR" },
  { code: "+353", country: "Ireland", flag: "🇮🇪", iso: "IE" },
  { code: "+45", country: "Denmark", flag: "🇩🇰", iso: "DK" },
  { code: "+46", country: "Sweden", flag: "🇸🇪", iso: "SE" },
  { code: "+47", country: "Norway", flag: "🇳🇴", iso: "NO" },
  { code: "+358", country: "Finland", flag: "🇫🇮", iso: "FI" },
  { code: "+420", country: "Czech Republic", flag: "🇨🇿", iso: "CZ" },
  { code: "+421", country: "Slovakia", flag: "🇸🇰", iso: "SK" },
  { code: "+36", country: "Hungary", flag: "🇭🇺", iso: "HU" },
  { code: "+385", country: "Croatia", flag: "🇭🇷", iso: "HR" },
  { code: "+386", country: "Slovenia", flag: "🇸🇮", iso: "SI" },
  { code: "+359", country: "Bulgaria", flag: "🇧🇬", iso: "BG" },
  { code: "+380", country: "Ukraine", flag: "🇺🇦", iso: "UA" },
  { code: "+7", country: "Russia", flag: "🇷🇺", iso: "RU" },
  { code: "+90", country: "Turkey", flag: "🇹🇷", iso: "TR" },
  { code: "+972", country: "Israel", flag: "🇮🇱", iso: "IL" },
  { code: "+971", country: "UAE", flag: "🇦🇪", iso: "AE" },
  { code: "+966", country: "Saudi Arabia", flag: "🇸🇦", iso: "SA" },
  { code: "+974", country: "Qatar", flag: "🇶🇦", iso: "QA" },
  { code: "+973", country: "Bahrain", flag: "🇧🇭", iso: "BH" },
  { code: "+965", country: "Kuwait", flag: "🇰🇼", iso: "KW" },
  { code: "+968", country: "Oman", flag: "🇴🇲", iso: "OM" },
  { code: "+962", country: "Jordan", flag: "🇯🇴", iso: "JO" },
  { code: "+961", country: "Lebanon", flag: "🇱🇧", iso: "LB" },
  { code: "+20", country: "Egypt", flag: "🇪🇬", iso: "EG" },
  { code: "+212", country: "Morocco", flag: "🇲🇦", iso: "MA" },
  { code: "+216", country: "Tunisia", flag: "🇹🇳", iso: "TN" },
  { code: "+213", country: "Algeria", flag: "🇩🇿", iso: "DZ" },
  { code: "+27", country: "South Africa", flag: "🇿🇦", iso: "ZA" },
  { code: "+234", country: "Nigeria", flag: "🇳🇬", iso: "NG" },
  { code: "+254", country: "Kenya", flag: "🇰🇪", iso: "KE" },
  { code: "+255", country: "Tanzania", flag: "🇹🇿", iso: "TZ" },
  { code: "+256", country: "Uganda", flag: "🇺🇬", iso: "UG" },
  { code: "+233", country: "Ghana", flag: "🇬🇭", iso: "GH" },
  { code: "+91", country: "India", flag: "🇮🇳", iso: "IN" },
  { code: "+92", country: "Pakistan", flag: "🇵🇰", iso: "PK" },
  { code: "+880", country: "Bangladesh", flag: "🇧🇩", iso: "BD" },
  { code: "+94", country: "Sri Lanka", flag: "🇱🇰", iso: "LK" },
  { code: "+977", country: "Nepal", flag: "🇳🇵", iso: "NP" },
  { code: "+86", country: "China", flag: "🇨🇳", iso: "CN" },
  { code: "+81", country: "Japan", flag: "🇯🇵", iso: "JP" },
  { code: "+82", country: "South Korea", flag: "🇰🇷", iso: "KR" },
  { code: "+852", country: "Hong Kong", flag: "🇭🇰", iso: "HK" },
  { code: "+886", country: "Taiwan", flag: "🇹🇼", iso: "TW" },
  { code: "+65", country: "Singapore", flag: "🇸🇬", iso: "SG" },
  { code: "+60", country: "Malaysia", flag: "🇲🇾", iso: "MY" },
  { code: "+62", country: "Indonesia", flag: "🇮🇩", iso: "ID" },
  { code: "+66", country: "Thailand", flag: "🇹🇭", iso: "TH" },
  { code: "+84", country: "Vietnam", flag: "🇻🇳", iso: "VN" },
  { code: "+63", country: "Philippines", flag: "🇵🇭", iso: "PH" },
  { code: "+61", country: "Australia", flag: "🇦🇺", iso: "AU" },
  { code: "+64", country: "New Zealand", flag: "🇳🇿", iso: "NZ" },
  { code: "+55", country: "Brazil", flag: "🇧🇷", iso: "BR" },
  { code: "+54", country: "Argentina", flag: "🇦🇷", iso: "AR" },
  { code: "+56", country: "Chile", flag: "🇨🇱", iso: "CL" },
  { code: "+57", country: "Colombia", flag: "🇨🇴", iso: "CO" },
  { code: "+51", country: "Peru", flag: "🇵🇪", iso: "PE" },
  { code: "+58", country: "Venezuela", flag: "🇻🇪", iso: "VE" },
  { code: "+52", country: "Mexico", flag: "🇲🇽", iso: "MX" },
  { code: "+506", country: "Costa Rica", flag: "🇨🇷", iso: "CR" },
  { code: "+507", country: "Panama", flag: "🇵🇦", iso: "PA" },
  { code: "+593", country: "Ecuador", flag: "🇪🇨", iso: "EC" },
  { code: "+598", country: "Uruguay", flag: "🇺🇾", iso: "UY" },
  { code: "+595", country: "Paraguay", flag: "🇵🇾", iso: "PY" },
  { code: "+591", country: "Bolivia", flag: "🇧🇴", iso: "BO" },
  { code: "+503", country: "El Salvador", flag: "🇸🇻", iso: "SV" },
  { code: "+502", country: "Guatemala", flag: "🇬🇹", iso: "GT" },
  { code: "+504", country: "Honduras", flag: "🇭🇳", iso: "HN" },
  { code: "+505", country: "Nicaragua", flag: "🇳🇮", iso: "NI" },
  { code: "+509", country: "Haiti", flag: "🇭🇹", iso: "HT" },
  { code: "+1809", country: "Dominican Republic", flag: "🇩🇴", iso: "DO" },
  { code: "+53", country: "Cuba", flag: "🇨🇺", iso: "CU" },
  { code: "+1876", country: "Jamaica", flag: "🇯🇲", iso: "JM" },
  { code: "+1868", country: "Trinidad", flag: "🇹🇹", iso: "TT" },
  { code: "+370", country: "Lithuania", flag: "🇱🇹", iso: "LT" },
  { code: "+371", country: "Latvia", flag: "🇱🇻", iso: "LV" },
  { code: "+372", country: "Estonia", flag: "🇪🇪", iso: "EE" },
  { code: "+375", country: "Belarus", flag: "🇧🇾", iso: "BY" },
  { code: "+373", country: "Moldova", flag: "🇲🇩", iso: "MD" },
  { code: "+381", country: "Serbia", flag: "🇷🇸", iso: "RS" },
  { code: "+382", country: "Montenegro", flag: "🇲🇪", iso: "ME" },
  { code: "+383", country: "Kosovo", flag: "🇽🇰", iso: "XK" },
  { code: "+387", country: "Bosnia", flag: "🇧🇦", iso: "BA" },
  { code: "+389", country: "North Macedonia", flag: "🇲🇰", iso: "MK" },
  { code: "+355", country: "Albania", flag: "🇦🇱", iso: "AL" },
  { code: "+357", country: "Cyprus", flag: "🇨🇾", iso: "CY" },
  { code: "+356", country: "Malta", flag: "🇲🇹", iso: "MT" },
  { code: "+352", country: "Luxembourg", flag: "🇱🇺", iso: "LU" },
  { code: "+354", country: "Iceland", flag: "🇮🇸", iso: "IS" },
  { code: "+376", country: "Andorra", flag: "🇦🇩", iso: "AD" },
  { code: "+377", country: "Monaco", flag: "🇲🇨", iso: "MC" },
  { code: "+378", country: "San Marino", flag: "🇸🇲", iso: "SM" },
  { code: "+379", country: "Vatican", flag: "🇻🇦", iso: "VA" },
  { code: "+423", country: "Liechtenstein", flag: "🇱🇮", iso: "LI" },
  { code: "+93", country: "Afghanistan", flag: "🇦🇫", iso: "AF" },
  { code: "+98", country: "Iran", flag: "🇮🇷", iso: "IR" },
  { code: "+964", country: "Iraq", flag: "🇮🇶", iso: "IQ" },
  { code: "+963", country: "Syria", flag: "🇸🇾", iso: "SY" },
  { code: "+967", country: "Yemen", flag: "🇾🇪", iso: "YE" },
  { code: "+960", country: "Maldives", flag: "🇲🇻", iso: "MV" },
  { code: "+95", country: "Myanmar", flag: "🇲🇲", iso: "MM" },
  { code: "+855", country: "Cambodia", flag: "🇰🇭", iso: "KH" },
  { code: "+856", country: "Laos", flag: "🇱🇦", iso: "LA" },
  { code: "+853", country: "Macau", flag: "🇲🇴", iso: "MO" },
  { code: "+673", country: "Brunei", flag: "🇧🇳", iso: "BN" },
  { code: "+975", country: "Bhutan", flag: "🇧🇹", iso: "BT" },
  { code: "+976", country: "Mongolia", flag: "🇲🇳", iso: "MN" },
  { code: "+850", country: "North Korea", flag: "🇰🇵", iso: "KP" },
  { code: "+670", country: "Timor-Leste", flag: "🇹🇱", iso: "TL" },
  { code: "+675", country: "Papua New Guinea", flag: "🇵🇬", iso: "PG" },
  { code: "+679", country: "Fiji", flag: "🇫🇯", iso: "FJ" },
  { code: "+676", country: "Tonga", flag: "🇹🇴", iso: "TO" },
  { code: "+685", country: "Samoa", flag: "🇼🇸", iso: "WS" },
  { code: "+678", country: "Vanuatu", flag: "🇻🇺", iso: "VU" },
  { code: "+677", country: "Solomon Islands", flag: "🇸🇧", iso: "SB" },
  { code: "+680", country: "Palau", flag: "🇵🇼", iso: "PW" },
  { code: "+691", country: "Micronesia", flag: "🇫🇲", iso: "FM" },
  { code: "+692", country: "Marshall Islands", flag: "🇲🇭", iso: "MH" },
  { code: "+686", country: "Kiribati", flag: "🇰🇮", iso: "KI" },
  { code: "+688", country: "Tuvalu", flag: "🇹🇻", iso: "TV" },
  { code: "+674", country: "Nauru", flag: "🇳🇷", iso: "NR" },
];

// Default country code (Italy)
export const defaultCountryCode = "+39";

// Get country by code
export const getCountryByCode = (code) => {
  return countryCodes.find(c => c.code === code) || countryCodes[0];
};

// Format phone number with country code
export const formatPhoneWithCode = (countryCode, number) => {
  const cleanNumber = number.replace(/[^\d]/g, '');
  return `${countryCode}${cleanNumber}`;
};

// Parse phone number to extract country code
export const parsePhoneNumber = (fullNumber) => {
  if (!fullNumber) return { countryCode: defaultCountryCode, number: '' };
  
  // Try to match country code
  for (const country of countryCodes) {
    if (fullNumber.startsWith(country.code)) {
      return {
        countryCode: country.code,
        number: fullNumber.slice(country.code.length)
      };
    }
  }
  
  // Default to Italy if no match
  return { countryCode: defaultCountryCode, number: fullNumber.replace(/^\+/, '') };
};
